<template>
  <v-snackbar-queue
    :model-value="messages"
    total-visible="5"
    location="bottom"
    content-class="mb-10"
    timeout="-1"
    closable
    @update:model-value="syncController"
  />
</template>

<script lang="ts">
import { computed, defineComponent, inject } from 'vue'

import { CONTROLLER_KEY } from '@/plugins/devtools/shared'

import type { QueuedDevtoolsMessage } from '@/plugins/devtools/api'
import type { SnackbarMessage } from 'vuetify/lib/components/VSnackbarQueue/VSnackbarQueue.mjs'

export default defineComponent({
  name: 'DevtoolsMessages',

  setup () {
    const controller = inject(CONTROLLER_KEY)!
    const messages = computed(() => controller.currentMessages)

    function syncController (remaining: SnackbarMessage[]): void {
      const queue = controller.currentMessages
      queue.splice(0, queue.length, ...remaining as QueuedDevtoolsMessage[])
    }

    return {
      messages,
      syncController,
    }
  },
})
</script>
